function initMap(mapID, lat, lng) {
  var pinPosition = {lat: lat, lng: lng};
  var map = new google.maps.Map(document.getElementById(mapID), {
    zoom: 13,
    center: pinPosition,
    zoomControl: true,
    zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
    },
    streetViewControl: false,
    mapTypeControl: false,
    styles:
        [{"featureType":"all","stylers":[{"saturation":0},{"hue":"#e7ecf0"}]},{"featureType":"road","stylers":[{"saturation":-70}]},{"featureType":"transit","stylers":[{"visibility":"off"}]},{"featureType":"poi","stylers":[{"visibility":"off"}]},{"featureType":"water","stylers":[{"visibility":"simplified"},{"saturation":-60}]}]
  });

  return map;
}

function addMarker(map, lat, lng, icon){
  var marker = new google.maps.Marker({
    position: {lat: lat, lng: lng},
    icon: icon,
    map: map
  });

  return marker;
}


function addTooltip(map, marker, tooltipContent){

  var tooltip = new google.maps.InfoWindow({
    content: tooltipContent
  });

  tooltip.open(map, marker);

  map.addListener(tooltip, 'domready', function() {

     var iwOuter = $('.gm-style-iw');
     var iwBackground = iwOuter.prev();

     iwBackground.children(':nth-child(2)').css({'display' : 'none'});
     iwBackground.children(':nth-child(4)').css({'display' : 'none'});

  });
}
